import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMarkdown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMarkdown"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 14.5V9.5H6.75L8.9 12H9.1L11.25 9.5H11.5V14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 9.5V13.75" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 12.5L16.5 14.5L18.5 12.5172" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMarkdown;
